/**
 * invoicesFilterFields.js
 *
 * Advanced filter field catalog for Invoices -- the per-entity config the shared
 * AdvancedFilterModal/Toolbar (src/features/AdvancedFilter) render from. Field keys and
 * operators match InvoiceDynamicSpecification.java's leaf handling on the backend field-for-field.
 */

const TEXT_OPS = ["CONTAINS", "EQ"];
const DATE_OPS = ["GTE", "LTE", "EQ"];
const NUMBER_OPS = ["GTE", "LTE", "EQ"];

export const INVOICE_STATUS_OPTIONS = ["New", "Approved", "Rejected", "Paid"];
export const INVOICE_PAYMENT_STATUS_OPTIONS = ["Not Invoiced", "Invoiced", "Paid"];

export const INVOICE_RULE_FIELDS = [
  {
    key: "invoiceNumber", label: "Invoice Number", type: "text", group: "Invoice",
    ops: TEXT_OPS, backendField: "invoiceNumber", placeholder: "e.g. INV-00123",
  },
  {
    key: "status", label: "Status", type: "select", group: "Invoice",
    options: INVOICE_STATUS_OPTIONS, ops: ["EQ", "NEQ"], backendField: "status",
  },
  {
    key: "paymentStatus", label: "Payment Status", type: "select", group: "Invoice",
    options: INVOICE_PAYMENT_STATUS_OPTIONS, ops: ["EQ", "NEQ"], backendField: "paymentStatus",
  },
  {
    key: "shipmentNumber", label: "Shipment Number", type: "text", group: "Invoice",
    ops: TEXT_OPS, backendField: "shipmentNumber", placeholder: "e.g. DIAMOND-MET-A00169",
  },
  {
    key: "paymentTerms", label: "Payment Terms", type: "text", group: "Invoice",
    ops: TEXT_OPS, backendField: "paymentTerms",
  },
  {
    key: "description", label: "Description", type: "text", group: "Invoice",
    ops: TEXT_OPS, backendField: "description",
  },

  { key: "carrier", label: "Carrier", type: "text", group: "Parties", ops: TEXT_OPS, backendField: "carrier" },
  { key: "billToCompanyName", label: "Bill To Company", type: "text", group: "Parties", ops: TEXT_OPS, backendField: "billToCompanyName" },
  { key: "payToCompanyName", label: "Pay To Company", type: "text", group: "Parties", ops: TEXT_OPS, backendField: "payToCompanyName" },
  { key: "billToOfficeCode", label: "Bill To Office Code", type: "text", group: "Parties", ops: TEXT_OPS, backendField: "billToOfficeCode" },
  { key: "payToOfficeCode", label: "Pay To Office Code", type: "text", group: "Parties", ops: TEXT_OPS, backendField: "payToOfficeCode" },

  { key: "invoiceDate", label: "Invoice Date", type: "date", group: "Dates", ops: DATE_OPS, backendField: "invoiceDate" },
  { key: "approvalDate", label: "Approval Date", type: "date", group: "Dates", ops: DATE_OPS, backendField: "approvalDate" },
  { key: "rejectedDate", label: "Rejected Date", type: "date", group: "Dates", ops: DATE_OPS, backendField: "rejectedDate" },

  { key: "total", label: "Total", type: "number", group: "Amounts", ops: NUMBER_OPS, backendField: "total" },
];
